import{
    SET_CURRENT_QUES_ID,
    SET_LEADERBOARD_LIST,
    SET_EDIT_LEADER_BOARD_LIST, 
    SET_LEADERBOARD_EVENTS,
    SET_LEADERBOARD_QUESTIONS,
    SET_EDIT_LEADER_BOARD_QUESTION_DATA,
    SET_DROPDOWN_QUESTIONS_LIST,
    SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING,
    SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING,
    SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING,
    SET_CONTINOUS_EVALUATE_PENDING,
    SET_IS_EDIT_LEADERBOARD_PENDING,
    SET_LOCK_EDITING_PENDING,
    SET_CURRENT_QUESTION_ID,
    SET_UNLOCK_EDITING_PENDING,
    SET_LEADERBOARD_SORT,
    SET_LEADERBOARD_QUESTION_SORT,
    IS_OPEN_PLAYER_MODEL,
    SET_LB_EXECUTE_PENDING,
    SET_LEADERBOARD_GAME_DATA,
    SET_OPPONENT_PLAYER_LIST,
    SET_LB_PLAYER2,
    SET_PLAY_LB_GAME,
    SET_EVALUATE_ISGAME,
    SET_GAME_LEADERBOARD,
    SET_EVALUATE_EVENTID,
    SET_LB_PLAYER1,
    OPEN_POINTS_TABLE,
    SET_POINTS_TABLE_PENDING,
    SET_POINTS_TABLE_DATA,
    SET_LB_UPDATED_TIME,
    RESULT_PLAYER_NAME
} from "../constants/leaderboard.constants";

const initialState: eventsState = {
    currentQuesID: null,
    leaderboardList: null,
    editLeaderboardList: null,
    editLeaderboardEventsList: null,
    editLeaderboardQuestionsList: null,
    editLeaderboardQuestionData: null,
    dropdownQuestionsList: null,
    isGetEventsleaderboardListsPending: false,
    isGetQuestionsleaderboardListsPending: false,
    isGetDropdownQuestionsListPending: false,
    isContinousEvaluatePending: false,
    isEditLeaderboardPending: false,
    isLockEditingPending: false,
    isEditingLocked: false,
    currentQuestionId: null,
    isUnlockEditingPending: false,
    allowRepeatedCalls: false,
    lockedUserId: null,
    leaderBoardSort: "rank",
    quesLeaderboardSort: "rank",
    isPlayerModelOpen: false,
    isLBExecutePending: false,
    leaderboardGameData: null,
    opponentPlayerList: [],
    leaderBoardOpponent: {
        id: null,
        name: null
    },
    playLBGame: false,
    evaluateIsGame: false,
    gameLeaderboard: null,
    evaluateEventId: null,
    player1LB: {
        id: null,
        name: null
    },
    isOpenPointsTable: false,
    isPointsTablePending: false,
    LBPointsTableData: {},
    LBUpdatedTime: null,
    resultantName: null
};

export default (
    localState: eventsState = initialState,
    action: Action
): eventsState => {
    switch(action.type)
    {

        case SET_CURRENT_QUES_ID: {
            return {
                ...localState,
                currentQuesID: action.payload
            }
        }

        case SET_LEADERBOARD_LIST: {
            const { leaderboardList } = action.payload
            return{
                ...localState,
                leaderboardList: leaderboardList
            }
        }

        case SET_EDIT_LEADER_BOARD_LIST: {
            return{
                ...localState,
                editLeaderboardList: action.payload
            }
        }
        case SET_LEADERBOARD_EVENTS:{
            return{
                ...localState,
                editLeaderboardEventsList: action.payload
    
            }
        }

        case SET_LEADERBOARD_QUESTIONS:{
            return{
                ...localState,
                editLeaderboardQuestionsList: action.payload
    
            }
        }

        case SET_EDIT_LEADER_BOARD_QUESTION_DATA:{
            return{
                ...localState,
                editLeaderboardQuestionData: action.payload,
            }
        }

        case SET_DROPDOWN_QUESTIONS_LIST:{
            return{
                ...localState,
                dropdownQuestionsList: action.payload,
            }
        }

        case SET_IS_GET_EVENTS_LEADERBOARD_LISTS_PENDING:{
            return{
                ...localState,
                isGetEventsleaderboardListsPending: action.payload,
            }
        }

        case SET_IS_GET_DROPDOWN_QUESTIONS_LIST_PENDING:{
            return{
                ...localState,
                isGetDropdownQuestionsListPending: action.payload,
            }
        }

        case SET_IS_GET_QUESTIONS_LEADERBOARD_LISTS_PENDING:{
            return{
                ...localState,
                isGetQuestionsleaderboardListsPending: action.payload,
            }
        }

        case SET_CONTINOUS_EVALUATE_PENDING:{
            return{
                ...localState,
                isContinousEvaluatePending: action.payload,
            }
        }

        case SET_IS_EDIT_LEADERBOARD_PENDING:{
            return{
                ...localState,
                isEditLeaderboardPending: action.payload,
            }
        }
        case SET_LOCK_EDITING_PENDING: {
            return {
                ...localState,
                isLockEditingPending: action.payload
            }
        }
        case SET_CURRENT_QUESTION_ID: {
            return {
                ...localState,
                currentQuestionId: action.payload,
                allowRepeatedCalls: true
            }
        }
        case SET_UNLOCK_EDITING_PENDING: {
            return {
                ...localState,
                isUnlockEditingPending: action.payload
            }
        }
        case SET_LEADERBOARD_SORT: {
            return {
                ...localState,
                leaderBoardSort: action.payload
            }
        }
        case SET_LEADERBOARD_QUESTION_SORT: {
            return {
                ...localState,
                quesLeaderboardSort: action.payload
            }
        }
        case IS_OPEN_PLAYER_MODEL: {
            return {
                ...localState,
                isPlayerModelOpen: action.payload
            }
        }
        case SET_LB_EXECUTE_PENDING: {
            return {
                ...localState,
                isLBExecutePending: action.payload
            }
        }
        case SET_LEADERBOARD_GAME_DATA: {
            return {
                ...localState,
                leaderboardGameData: action.payload
            }
        }
        case SET_OPPONENT_PLAYER_LIST: {
            return {
                ...localState,
                opponentPlayerList: action.payload
            }
        }
        case SET_LB_PLAYER2: {
            return {
                ...localState,
                leaderBoardOpponent: action.payload
            }
        }
        case SET_PLAY_LB_GAME: {
            return {
                ...localState,
                playLBGame: action.payload
            }
        }
        case SET_EVALUATE_ISGAME: {
            return {
                ...localState,
                evaluateIsGame: action.payload
            }
        }
        case SET_GAME_LEADERBOARD: {
            return {
                ...localState,
                gameLeaderboard: action.payload
            }
        }
        case SET_EVALUATE_EVENTID: {
            return{
                ...localState,
                evaluateEventId: action.payload
            }
        }
        case SET_LB_PLAYER1: {
            return {
                ...localState,
                player1LB: action.payload
            }
        }
        case OPEN_POINTS_TABLE: {
            return {
                ...localState,
                isOpenPointsTable: action.payload
            }
        }
        case SET_POINTS_TABLE_PENDING: {
            return {
                ...localState,
                isPointsTablePending: action.payload
            }
        }
        case SET_POINTS_TABLE_DATA: {
            return {
                ...localState,
                LBPointsTableData: action.payload
            }
        }
        case SET_LB_UPDATED_TIME: {
            return {
                ...localState,
                LBUpdatedTime: action.payload
            }
        }
        case RESULT_PLAYER_NAME: {
            return {
                ...localState,
                resultantName: action.payload
            }
        }
        default: {
            return localState;
        }
    }
}